export const Style = ({ colors = [] }) => (
  <g id="Estilo10">
    <linearGradient
      id="SVGID_153_"
      gradientUnits="userSpaceOnUse"
      x1="91.3843"
      y1="-319.03"
      x2="99.6734"
      y2="-319.03"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_153_)' }}
      d="M95.2,71.6c1.6-1.8,5.4-7.6,4.3-21.3l-3.6,3.5l1.1,4.8 C96.5,64.5,95.8,68.6,95.2,71.6z"
    />

    <linearGradient
      id="SVGID_154_"
      gradientUnits="userSpaceOnUse"
      x1="51.8635"
      y1="414.97"
      x2="56.37"
      y2="414.97"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_154_)' }}
      d="M55,57.2L52.6,59c-2.6,9.7,2.3,13.1,3.8,13.8c-0.8-4.4-1.6-9.8-1.6-11.8 L55,57.2z"
    />

    <linearGradient
      id="Multiply_57_"
      gradientUnits="userSpaceOnUse"
      x1="76.15"
      y1="435.1696"
      x2="76.15"
      y2="405.1755"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
      <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
      <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
      <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
      <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
    </linearGradient>
    <path
      id="Multiply_32_"
      style={{
        display: 'inline',
        opacity: '0.6',
        fill: 'url(#Multiply_57_)',
        enableBackground: 'new',
        mixBlendMode: 'multiply'
      }}
      d="M98,55.3 C98,47.8,90.3,42,82.8,42H69c-8,0-14.5,6.5-14.6,14.5l-0.1,10.4c0,0,0,0,0,0l0,0c2.5,0,4.1-1.3,5.9-2.6l0.3-0.2 c2.5-1.9,3.8-4.8,4.5-8c3.3,3.3,7.9,5,13.7,5.1c12.6,0.2,17.2,5,17.8,7.4c0,0,0,0,0.1,0L98,55.3z"
    />
    <path
      style={{ display: 'inline', fill: '#401F43' }}
      d="M90.1,60.4c0.2-0.1-6.4-4.3-10.5-4.1c-0.1,0.1,0.4-4.6,5.8-2.7 C90.6,55.8,90,60.5,90.1,60.4z"
    />
    <path
      style={{ display: 'inline', fill: '#401F43' }}
      d="M60.1,60.4c-0.2-0.1,6.4-4.3,10.5-4.1c0.1,0.1-0.1-4.5-5.5-2.5 C59.8,55.9,60.1,60.5,60.1,60.4z"
    />

    <linearGradient
      id="SVGID_155_"
      gradientUnits="userSpaceOnUse"
      x1="48.3875"
      y1="434.7157"
      x2="102.5941"
      y2="434.7157"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_155_)' }}
      d="M98.6,36.9c-6.8-9.6-36.2-19.4-49.7,6.8c-2.2,4.2,3.3,18.4,3.3,18.4 c1.8,0,3-0.9,4.9-2.2c4.1-2.8,4.3-8.9,4.7-14.8c1.5,5,5.4,11.2,17.2,11.3c17.9,0.2,19.6,7.3,19.6,7.3S107.6,49.5,98.6,36.9z"
    />
  </g>
)

export const Back = ({ colors = [] }) => <></>

Style.Back = Back
